import { render, staticRenderFns } from "./Contact-card-by-type.vue?vue&type=template&id=18d59081&scoped=true&"
import script from "./Contact-card-by-type.vue?vue&type=script&lang=js&"
export * from "./Contact-card-by-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d59081",
  null
  
)

export default component.exports